import { useTranslation } from 'react-i18next';
import { LegalDocument } from '../components/LegalDocument';
import { PageMeta } from '../components/PageMeta';
import { getLegalBlocks } from '../content/legal-index';
import type { LandingLocale } from '../i18n';

export function LegalPage() {
  const { i18n } = useTranslation();
  const locale: LandingLocale = i18n.language?.startsWith('en') ? 'en' : 'el';
  const blocks = getLegalBlocks(locale);

  return (
    <>
      <PageMeta titleKey="legalPage.metaTitle" descriptionKey="legalPage.metaDescription" />

      <div className="legal-page">
        <LegalDocument blocks={blocks} />
      </div>
    </>
  );
}
